import React, { useState, useRef, useEffect } from 'react';
import { UiTab, UiTable, UiButton, UiRangePicker, UiSearch, UiSelect } from '../../../components';
import { actionDots, downloadReport } from '../../../assets/images';
import { DatePicker, Dropdown, Menu, Space, Modal } from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { useDispatch, useSelector } from 'react-redux';
import { loaderReducer } from '../../../reducer/loader.reducer';
import { searchInitiateDelayTime, tablePageSizeOptions, formatAmount, parseErrorMessage, isConsultationRefundExpired } from '../../../utils/appUtils';
import { tabData, actionDropdownMenu, LAWYERS_COLUMNS, CUSTOMERS_COLUMNS, handleMessageTabChange, complaintStatusOptions, refundPercentageOptions, checkIsConsultationRecorded } from './config';
import { COMPLAINTS, LAWYERMANAGEMENT, CUSTOMERMANAGEMENT, SENDMESSAGEWHATSAPP, SENDMESSAGEMAILID, CONSULTATION, TRANSACTIONMANAGEMENT, PAYMENTMANAGEMENT } from "../../../apiServices/endpoints";
import { useReactToPrint } from 'react-to-print';
import { showErrorNotification, showSuccessNotification } from '../../../components/uiNotification';
import AllCompliantReport from './reports/allCompliantReport';
import ComplaintActionDrawer from './compliantdrawer';
import ConsultationView from '../../../components/consultation/consultationView';
import * as api from '../../../actions';

const PrintAllCompliantReport = React.forwardRef((props, ref) => {
	return <div ref={ref}>
		<AllCompliantReport
			data={props?.data}
			date={props?.date}
			reportType={props?.reportType}
			getPdfTitle={props?.getPdfTitle}
			complaintStatus={props?.complaintStatus}
			selectedMonth={props?.selectedMonth}
			selectedMonthString={props?.selectedMonthString}
		/>
	</div>
});

const Compliant = () => {
	const queryClient = useQueryClient();
	const dispatch = useDispatch();
	const debounceTimeOut = useRef(null);
	const reportRef = useRef(null);
	const userId = sessionStorage.getItem("userId");
	const configResults = useSelector((state) => state?.configAction?.configData);
	const recordFeeConfig = configResults?.find((detail) => (detail?.configId || "").trim() === "recordSessionFee");
	const recordFee = Number(recordFeeConfig?.defaultValue !== undefined && recordFeeConfig?.defaultValue !== null && recordFeeConfig?.defaultValue !== "" ? recordFeeConfig.defaultValue : (recordFeeConfig?.configuration?.[0] || 0)) || 0;
	const [screenState, setScreenState] = useState({
		activeTab: "LAWYERS",
		activeTabKey: "1",
		pageSize: { page: 0, size: 10 },
		date: { fromDate: "", toDate: "" },
		searchFilter: "",
		searchTermValue: "",
		selectMonth: null,
		selectedMonthString: "",
		complaintStatus: "PENDING",
		complaintData: [],
		isReportOpen: false,
		isOpen: false,
		drawerComplaintData: null,
		consultation: null,
		selectedComplaintId: null,
		raisedByProfileUrl: null,
		againstByProfileUrl: null,
		messageModalOpen: false,
		isWarningMessage: false
	});
	const [consultationBooleans, setConsultationBooleans] = useState({
		isComplaintDrawerOpen: false,
		isDownloadButtonEnable: false,
		isSendMessage: false,
		isSendWarningMessage: false,
		isconsultationDrawerOpen: false,
	});
	const [consultationIdData, setConsultationIdData] = useState({ lawyerProfile: "", customerProfile: "", consultationInfo: {} });
	const [consultation] = useState({ activeTab: "COMPLETED" });
	const [refundModal, setRefundModal] = useState({
		open: false,
		loading: false,
		consultationNo: "",
		customerName: "",
		customerTransactionId: "",
		totalAmount: 0,
		amount: "",
		percentage: "100%",
		userId: "",
		consultationId: "",
		complaintId: null,
		refundId: null,
		record: false
	});
	const [messageData, setMessageData] = useState({
		message: "",
		template: "",
		sendTo: "",
		subject: "",
		body: "",
		isWhatsapp: false,
		isMail: true,
		activeTabKey: "1",
		activeTab: "raised",
		complaintType: "",
		raisedById: "",
		againstById: "",
		warning: false,
		complaintId: "",
		warnedBy: "",
		isButtonEnable: false
	});
	const [sendMessagePayload, setSendMessagePayload] = useState(null);
	const [sendMailPayload, setSendMailPayload] = useState(null);
	const [completeModal, setCompleteModal] = useState({ open: false, complaintId: null });
	const handlePrint = useReactToPrint({
		content: () => reportRef.current,
		onAfterPrint: () => setScreenState(prev => ({ ...prev, isReportOpen: false, pageSize: { ...prev.pageSize, size: 10 } })),
		pageStyle: ` body {
			-webkit-print-color-adjust: exact;
			print-color-adjust: exact;
		}
		.print-page::before {
			content: "";
			position: fixed;
			top: 0;
			left: 0;
			right: 0;
			bottom: 0;
			border: 2px solid #005D60;
			z-index: 9999;
			pointer-events: none;
		}`
	});

	const getComplaintDetails = (activeTab, date, searchTermValue, page, size, complaintStatus, selectedMonthString) => api.get(`${COMPLAINTS}/page?page=${page}&size=${size}&complaintType=${activeTab === "LAWYERS" ? "COMPLAINT_RAISED_CUSTOMER" : "COMPLAINT_RAISED_LAWYER"}${complaintStatus ? `&complaintStatus=${complaintStatus}` : ""}${selectedMonthString ? `&month=${selectedMonthString}` : ""}${date?.fromDate && date?.toDate ? `&fromDate=${date?.fromDate}&toDate=${date?.toDate}` : ""}${searchTermValue ? `&commonSearch=${searchTermValue}` : ""}`);
	const getComplaintDetailsById = (complaintId) => api.get(`${COMPLAINTS}/${complaintId}`);
	const sendWhatsAppMessage = (payload) => api.post(SENDMESSAGEWHATSAPP, payload);
	const sendMailMessage = (payload) => api.post(SENDMESSAGEMAILID, payload);
	const completeComplaint = (complaintId) => api.patch(`${COMPLAINTS}/move_complaint${complaintId}`);
	const getConsultationById = (id) => api.get(`${CONSULTATION}/${id}`);

	const { isFetching: isFetchingConsultationById } = useQuery(
		["FETCH_CONSULTATION_BY_ID", ""],
		getConsultationById,
		{
			onSuccess: (consultationIdResponse) => {
				if (consultationIdResponse?.statusCode === 200) {
					setConsultationBooleans(prev => ({ ...prev, isconsultationDrawerOpen: true }));
					setConsultationIdData(prev => ({
						...prev,
						lawyerProfile: `${LAWYERMANAGEMENT}/file${consultationIdResponse?.result?.consultationResponse?.lawyerResponse?.profileUrl}`,
						customerProfile: `${CUSTOMERMANAGEMENT}/file${consultationIdResponse?.result?.consultationResponse?.customerResponse?.profileUrl}`,
						consultationInfo: consultationIdResponse?.result?.consultationResponse
					}));
				}
			},
			enabled: false,
			refetchOnWindowFocus: false
		}
	);

	const { data: complaintDetailsData, isFetching: isFetchingComplaintDetails, refetch: fetchComplaintDetails } = useQuery(
		["FETCH_ALL_COMPLAINTS", screenState?.activeTab, screenState?.date, screenState?.searchTermValue, screenState?.pageSize?.page, screenState?.pageSize?.size, screenState?.complaintStatus, screenState?.selectedMonthString],
		() => getComplaintDetails(screenState?.activeTab, screenState?.date, screenState?.searchTermValue, screenState?.pageSize?.page, screenState?.pageSize?.size, screenState?.complaintStatus, screenState?.selectedMonthString),
		{
			onSuccess: (complaintResponse) => {
				if (complaintResponse?.statusCode === 200) {
					setScreenState(prev => ({ ...prev, complaintData: complaintResponse?.result?.complaintResponsePage?.content }));
				}
			},
			enabled: Boolean(screenState?.activeTab || screenState?.date || screenState?.searchTermValue || screenState?.pageSize),
			refetchOnWindowFocus: false
		}
	);

	const { isFetching: isFetchingComplaintById } = useQuery(
		["FETCH_COMPLAINT_DETAILS", ""],
		getComplaintDetailsById,
		{
			onSuccess: (response) => {
				if (response?.statusCode === 200) {
					const complaintResponse = response?.result?.complaintResponse;
					const isCustomerRaised = screenState?.activeTab === "LAWYERS";
					const raisedByProfileUrl = complaintResponse?.raisedByProfileUrl ? `${isCustomerRaised ? CUSTOMERMANAGEMENT : LAWYERMANAGEMENT}/file${complaintResponse?.raisedByProfileUrl}` : null;
					const againstByProfileUrl = complaintResponse?.againstByProfileUrl ? `${isCustomerRaised ? LAWYERMANAGEMENT : CUSTOMERMANAGEMENT}/file${complaintResponse?.againstByProfileUrl}` : null;
					setScreenState(prev => ({
						...prev,
						drawerComplaintData: complaintResponse,
						raisedByProfileUrl: raisedByProfileUrl,
						againstByProfileUrl: againstByProfileUrl,
						consultation: { profile: againstByProfileUrl },
						isOpen: true
					}));
					setConsultationBooleans(prev => ({
						...prev,
						isComplaintDrawerOpen: true
					}));
				} else {
					setScreenState(prev => ({ ...prev, drawerComplaintData: null, raisedByProfileUrl: null, againstByProfileUrl: null, consultation: { profile: null } }));
					showErrorNotification("Error", response?.response?.data?.error?.message || response?.data?.error?.message || response?.message || "Failed to fetch complaint details");
				}
			},
			enabled: false,
			refetchOnWindowFocus: false
		}
	);

	const { isFetching: isFetchingSendMessage, refetch: refetchWhatsApp } = useQuery(["SEND_MESSAGE_WHATSAPP"], () => sendWhatsAppMessage(sendMessagePayload), {
		onSuccess: (sendResponse) => {
			if (sendResponse?.data?.statusCode === 200) {
				setConsultationBooleans(prev => ({ ...prev, isSendMessage: false, isSendWarningMessage: false }));
				updateMessageData({ activeTab: "raised", activeTabKey: "1", isMail: true, isWhatsapp: false, body: "", subject: "" });
				setSendMessagePayload(null);
				showSuccessNotification("Success", sendResponse?.data?.result?.message);
				setConsultationBooleans(prev => ({ ...prev, isComplaintDrawerOpen: false }));
				fetchComplaintDetails();
			}
			else {
				showErrorNotification("Error", sendResponse?.response?.data?.error?.message || sendResponse?.data?.error?.message || sendResponse?.message || "Failed to send WhatsApp message");
			}
		},
		enabled: false,
		refetchOnWindowFocus: false
	});

	const { isFetching: isFetchingSendMail, refetch: refetchMail } = useQuery(["SEND_MESSAGE_MAIL"], () => sendMailMessage(sendMailPayload), {
		onSuccess: (mailResponse) => {
			if (mailResponse?.data?.statusCode === 200) {
				setConsultationBooleans(prev => ({ ...prev, isSendMessage: false, isSendWarningMessage: false }));
				updateMessageData({ activeTab: "raised", activeTabKey: "1", isMail: true, isWhatsapp: false, body: "", subject: "" });
				setSendMailPayload(null);
				showSuccessNotification("Success", mailResponse?.data?.result?.response);
				setConsultationBooleans(prev => ({ ...prev, isComplaintDrawerOpen: false }));
				fetchComplaintDetails();
			}
			else {
				showErrorNotification("Error", mailResponse?.response?.data?.error?.message || mailResponse?.data?.error?.message || mailResponse?.message || "Failed to send mail");
			}
		},
		enabled: false,
		refetchOnWindowFocus: false
	});

	const { isFetching: isFetchingCompleteComplaint, refetch: refetchCompleteComplaint } = useQuery(
		["COMPLETE_COMPLAINT", completeModal?.complaintId],
		() => completeComplaint(completeModal?.complaintId),
		{
			onSuccess: (response) => {
				if (response?.data?.statusCode === 200) {
					showSuccessNotification("Success", response?.data?.result?.message || "Complaint completed successfully");
					handleCloseCompleteModal();
					setConsultationBooleans(prev => ({ ...prev, isconsultationDrawerOpen: false }));
					fetchComplaintDetails();
				}
				else {
					showErrorNotification("Error", response?.response?.data?.error?.message || response?.data?.error?.message || response?.message || "Failed to complete complaint");
				}
			},
			enabled: false,
			refetchOnWindowFocus: false
		}
	);

	const handleTabChanges = (key) => {
		if (!tabData || !Array.isArray(tabData)) return;
		tabData?.forEach((tab) => {
			if (tab && tab?.key === key) {
				const { content } = tab || {};
				if (content) {
					setScreenState(prev => ({
						...prev,
						activeTab: content,
						activeTabKey: key,
						pageSize: { page: 0, size: 10 },
						date: { fromDate: "", toDate: "" },
						searchFilter: "",
						searchTermValue: "",
						selectMonth: null,
						selectedMonthString: "",
						complaintStatus: "PENDING"
					}));
				}
			}
		});
	};

	const handleCloseCompleteModal = () => {
		setCompleteModal(prev => ({ ...prev, open: false, complaintId: null }));
	};

	const handlePagination = (page, size) => {
		setScreenState(prev => ({ ...prev, pageSize: { page: page - 1, size: size } }));
	};

	const handleAction = (menuType, list) => {
		if (menuType === "view") {
			setScreenState(prev => ({
				...prev,
				selectedComplaintId: list?.complaintId
			}));
			queryClient.prefetchQuery(["FETCH_COMPLAINT_DETAILS", ""], () => getComplaintDetailsById(list?.complaintId));
		} else if (menuType === "complete") {
			setCompleteModal(prev => ({ ...prev, open: true, complaintId: list?.complaintId }));
		} else if (menuType === "refund") {
			if (screenState?.activeTab === "CUSTOMERS" || list?.complaintType === "COMPLAINT_RAISED_LAWYER") {
				return;
			}
			const consultationDate = list?.consultationDate || list?.consultationDetails?.consultationDate;
			if (isConsultationRefundExpired(consultationDate)) {
				showErrorNotification("Error", "Refund window has expired (more than 2 days after consultation date)");
				return;
			}
			setScreenState(prev => ({
				...prev,
				selectedComplaintId: list?.complaintId
			}));
			handleInitiateRefund(list);
		}
	};

	const handleConfirmComplete = () => {
		if (completeModal?.complaintId && !isFetchingCompleteComplaint) {
			refetchCompleteComplaint();
		}
	};

	const handleInitiateRefund = async (item) => {
		const complaintId = item?.complaintId || screenState?.selectedComplaintId;
		if (!complaintId) {
			showErrorNotification("Error", "Complaint ID not found");
			return;
		}
		try {
			const res = await getComplaintDetailsById(complaintId);
			const complaintResponse = res?.data?.result?.complaintResponse || res?.result?.complaintResponse;
			if (!complaintResponse) {
				showErrorNotification("Error", "Failed to retrieve complaint details");
				return;
			}
			handleOpenRefundModal(complaintResponse);
		} catch (error) {
			showErrorNotification("Error", error?.response?.data?.error?.message || error?.message || "Failed to retrieve complaint details");
		}
	};

	const handleRefundPercentageChange = (percentageVal) => {
		const pct = parseInt(percentageVal?.replace("%", ""), 10) || 100;
		const total = Number(Number(refundModal?.totalAmount || 0).toFixed(2));
		const calculatedAmount = Number(((total * pct) / 100).toFixed(2));
		setRefundModal((prev) => ({
			...prev,
			percentage: percentageVal,
			amount: formatAmount(calculatedAmount)
		}));
	};

	const handleOpenRefundModal = (data) => {
		const complaintData = data?.complaintId ? data : screenState?.drawerComplaintData;
		const consultationInfo = data?.consultationInfo || data?.consultationDetails || complaintData?.consultationDetails || consultationIdData?.consultationInfo || {};

		const consultationDate = consultationInfo?.consultationDate || complaintData?.consultationDate || complaintData?.consultationDetails?.consultationDate;
		if (isConsultationRefundExpired(consultationDate)) {
			showErrorNotification("Error", "Refund window has expired (more than 2 days after consultation date)");
			return;
		}

		const isRefunded = Boolean(consultationInfo?.isRefunded || consultationInfo?.refundStatus === "REFUNDED" || consultationInfo?.refundStatus === "SUCCESS" || Number(consultationInfo?.refundAmount || 0) > 0);
		if (isRefunded) {
			showErrorNotification("Error", "Refund has already been processed for this consultation");
			return;
		}

		const customerTransactionId = consultationInfo?.consultationPaymentDetails?.customerTransactionId;
		if (!customerTransactionId) {
			showErrorNotification("Error", "Customer Transaction ID not found");
			return;
		}

		const consultationNo = consultationInfo?.consultationNo || complaintData?.consultationNo || "";
		const customerName = (
			(complaintData?.complaintType === "COMPLAINT_RAISED_CUSTOMER" ? complaintData?.raisedByName : complaintData?.againstByName)
			|| (consultationInfo?.customerResponse ? `${consultationInfo?.customerResponse?.firstName || ""} ${consultationInfo?.customerResponse?.lastName || ""}`.trim() : "")
			|| consultationInfo?.customerName
			|| "-"
		);
		const rawTotalAmount = consultationInfo?.consultationPaymentDetails?.totalConsultationAmount || 0;
		const totalAmount = Number(Number(rawTotalAmount).toFixed(2));
		const userId = consultationInfo?.customerId || consultationInfo?.customerResponse?.customerId || (complaintData?.complaintType === "COMPLAINT_RAISED_CUSTOMER" ? complaintData?.raisedById : complaintData?.againstById) || "";
		const consultationId = consultationInfo?.consultationId || complaintData?.consultationId || "";
		const complaintId = complaintData?.complaintId || screenState?.selectedComplaintId || null;
		const isRecorded = checkIsConsultationRecorded(data, complaintData, consultationInfo);

		setRefundModal({
			open: true,
			loading: false,
			consultationNo,
			customerName,
			customerTransactionId,
			totalAmount,
			amount: formatAmount(totalAmount),
			percentage: "100%",
			userId,
			consultationId,
			complaintId,
			refundId: consultationInfo?.refundId || null,
			record: isRecorded
		});
	};

	const handleConfirmRefund = async () => {
		const customerTransactionId = refundModal?.customerTransactionId;
		const refundAmount = Number(Number(refundModal?.amount || 0).toFixed(2));
		const totalAmount = Number(Number(refundModal?.totalAmount || 0).toFixed(2));

		if (!customerTransactionId) {
			showErrorNotification("Error", "Customer Transaction ID not found");
			return;
		}

		if (!refundAmount || refundAmount <= 0) {
			showErrorNotification("Error", "Please enter a valid refund amount");
			return;
		}

		if (totalAmount > 0 && refundAmount > totalAmount) {
			showErrorNotification("Error", "Refund amount cannot exceed total consultation amount");
			return;
		}

		setRefundModal((prev) => ({ ...prev, loading: true }));
		try {
			const txnRes = await api.get(`${TRANSACTIONMANAGEMENT}/${customerTransactionId}`);
			const txnData = txnRes?.data ?? txnRes;
			const txn = txnData?.result?.transactionResponse;

			if (!txn) {
				showErrorNotification("Error", txnData?.error?.message || "Failed to retrieve transaction details");
				setRefundModal((prev) => ({ ...prev, loading: false }));
				return;
			}

			const isRecorded = Boolean(
				refundModal?.record ||
				checkIsConsultationRecorded(
					txn,
					screenState?.drawerComplaintData,
					consultationIdData?.consultationInfo
				)
			);

			let refundPercentage = null;
			if (refundModal?.percentage) {
				refundPercentage = parseFloat(String(refundModal.percentage).replace("%", ""));
			} else if (refundModal?.totalAmount > 0 && refundAmount > 0) {
				refundPercentage = (refundAmount / refundModal.totalAmount) * 100;
			}

			const isPercentageRefund = refundPercentage !== null && !isNaN(refundPercentage) && refundPercentage > 0 && refundPercentage < 100;

			const payoutPayload = {
				userId: txn?.userId || refundModal?.userId || "",
				transactionType: "CREDIT",
				paymentCategory: "REFUND_TO_CUSTOMER",
				transactionDate: dayjs().format("YYYY-MM-DD"),
				amount: refundAmount,
				razorpayFee: Number(txn?.razorpayFee ?? 0),
				finalAmount: refundAmount,
				referenceId: txn?.referenceId || null,
				refundId: txn?.refundId || refundModal?.refundId || null,
				razorpayPaymentId: txn?.razorpayPaymentId || null,
				consultationIds: Array.isArray(txn?.consultationIds) && txn?.consultationIds?.length > 0
					? txn?.consultationIds
					: (refundModal?.consultationId ? [refundModal?.consultationId] : []),
				status: "SUCCESS",
				customerTransactionId: txn?.transactionId || customerTransactionId,
				gatewayFees: Number(txn?.gatewayFees ?? txn?.razorpayFee ?? 0),
				lawyerFee: Number(txn?.lawyerFee ?? 0),
				tdsAmount: Number(txn?.tdsAmount ?? 0),
				manualRefund: true
			};

			if (isRecorded) {
				payoutPayload.record = true;
			}

			if (isPercentageRefund) {
				payoutPayload.split = true;
				if (isRecorded) {
					const balancePercentage = 100 - refundPercentage;
					payoutPayload.recordAmount = Number(((recordFee * balancePercentage) / 100).toFixed(2));
				}
			}

			const refundRes = await api.post(`${PAYMENTMANAGEMENT}/create_transaction_for_payout`, payoutPayload);
			const refundData = refundRes?.data ?? refundRes;

			const isSuccess =
				refundRes?.status === 200 ||
				refundRes?.status === 201 ||
				(typeof refundData === "string" && refundData.trim().length > 0) ||
				refundData?.statusCode === 200 ||
				refundData?.statusCode === 201 ||
				refundData?.status === "OK" ||
				refundData?.status === 200;
			const isError =
				refundData?.error ||
				(typeof refundData?.statusCode === "number" && refundData?.statusCode >= 400) ||
				refundData?.status === "ERROR";

			if (isSuccess && !isError) {
				showSuccessNotification("Success", typeof refundData === "object" ? (refundData?.result?.message || refundData?.message || "Refund processed successfully") : "Refund processed successfully");
				setRefundModal({
					open: false,
					loading: false,
					consultationNo: "",
					customerName: "",
					customerTransactionId: "",
					totalAmount: 0,
					amount: "",
					percentage: "100%",
					userId: "",
					consultationId: "",
					complaintId: null,
					refundId: null,
					record: false
				});
				setConsultationBooleans(prev => ({ ...prev, isconsultationDrawerOpen: false, isComplaintDrawerOpen: false }));
				setScreenState(prev => ({
					...prev,
					isOpen: false,
					drawerComplaintData: null,
					selectedComplaintId: null,
					raisedByProfileUrl: null,
					againstByProfileUrl: null,
					consultation: null
				}));
				fetchComplaintDetails();
			} else {
				showErrorNotification(
					"Error",
					parseErrorMessage(refundData?.error?.message || refundData?.response?.data?.error?.message || refundData?.message, "Failed to process refund")
				);
				setRefundModal((prev) => ({ ...prev, loading: false }));
			}
		} catch (error) {
			showErrorNotification(
				"Error",
				parseErrorMessage(error?.response?.data?.error?.message || error?.message, "Failed to process refund")
			);
			setRefundModal((prev) => ({ ...prev, loading: false }));
		}
	};

	const menuList = (menuItems, list) => {
		if (!menuItems || !Array.isArray(menuItems)) return <Menu></Menu>;
		return <Menu>
			{
				menuItems?.map((menuDetails) => {
					if (!menuDetails || !menuDetails?.key) return null;
					return <Menu.Item key={menuDetails?.key}
						onClick={(event) => {
							event?.domEvent?.stopPropagation();
							handleAction(menuDetails?.key, list);
						}}
					>{menuDetails?.label || ""}</Menu.Item>
				})
			}
		</Menu>
	};

	const actionRender = (list) => {
		let filteredMenuItems = actionDropdownMenu;
		if (screenState?.complaintStatus === "COMPLETED") {
			filteredMenuItems = filteredMenuItems?.filter(item => item?.key !== "complete");
		}
		if (screenState?.activeTab === "CUSTOMERS" || list?.complaintType === "COMPLAINT_RAISED_LAWYER") {
			filteredMenuItems = filteredMenuItems?.filter(item => item?.key !== "refund");
		}
		return <div style={{ textAlign: "center" }} onClick={(event) => event?.stopPropagation()}>
			<Dropdown overlay={menuList(filteredMenuItems, list)} trigger={["click"]}>
				<Space onClick={(event) => {
					event?.preventDefault();
					event?.stopPropagation();
				}} style={{ cursor: "pointer" }}>
					<img src={actionDots} alt="Action Dots" style={{ cursor: "pointer" }} />
				</Space>
			</Dropdown>
		</div>
	};

	const handleComplaintRowClick = (complaintDetail) => {
		handleAction("view", complaintDetail);
	};

	const handleDateChange = (date, type) => {
		const fromDate = dayjs(date?.[0]).format("YYYY-MM-DD");
		const toDate = dayjs(date?.[1]).format("YYYY-MM-DD");
		if (date) {
			if (fromDate && toDate) {
				if (type === "compliant") {
					setScreenState(prev => ({
						...prev,
						date: { fromDate: fromDate, toDate: toDate },
						selectMonth: null,
						selectedMonthString: ""
					}));
				}
			}
		} else {
			if (type === "compliant") {
				setScreenState(prev => ({
					...prev,
					date: { fromDate: "", toDate: "" }
				}));
			}
		}
	};

	const handleSearch = (searchValue) => {
		const searchTerm = searchValue;
		setScreenState(prev => ({ ...prev, searchFilter: searchTerm }));
		debounceSearch(searchTerm);
	};

	const debounceSearch = (searchTerm) => {
		if (debounceTimeOut?.current && typeof debounceTimeOut?.current === 'number') {
			clearTimeout(debounceTimeOut?.current);
		}
		if (searchTerm && searchTerm !== "") {
			debounceTimeOut.current = setTimeout(() => {
				if (setScreenState) {
					setScreenState(prev => ({
						...prev,
						searchTermValue: searchTerm,
						pageSize: { page: 0, size: 10 }
					}));
				}
			}, searchInitiateDelayTime);
		} else {
			if (setScreenState) {
				setScreenState(prev => ({
					...prev,
					searchTermValue: "",
					pageSize: { page: 0, size: 10 }
				}));
			}
		}
	};

	const handleMonthChange = (month, type) => {
		if (type === "compliant") {
			if (month) {
				const monthValue = dayjs(month).format("YYYY-MM");
				setScreenState(prev => ({
					...prev,
					selectMonth: month,
					selectedMonthString: monthValue,
					date: { fromDate: "", toDate: "" }
				}));
			} else {
				setScreenState(prev => ({
					...prev,
					selectMonth: null,
					selectedMonthString: ""
				}));
			}
		}
	};

	const handleComplaintStatusChange = (value) => {
		setScreenState(prev => ({ ...prev, complaintStatus: value, pageSize: { page: 0, size: 10 } }));
	};

	const handleReportPrint = () => {
		setScreenState(prev => ({ ...prev, pageSize: { ...prev.pageSize, size: -1 }, isReportOpen: true }));
	};

	const handleSubmitMessage = () => {
		if (!messageData) return;
		const basePayload = {
			...(messageData?.activeTab === "against" && messageData?.againstById ? { againstById: messageData?.againstById } : {}),
			...(messageData?.activeTab === "raised" && messageData?.raisedById ? { raisedById: messageData?.raisedById } : {}),
			complaintType: messageData?.complaintType || "",
			subject: messageData?.subject || "",
			body: messageData?.body || "",
			warning: messageData?.warning || false,
			complaintId: messageData?.complaintId || "",
			warnedBy: messageData?.warnedBy || ""
		}
		if (messageData?.isWhatsapp && setSendMessagePayload) {
			const warnedInArray = [];
			if (messageData?.isWhatsapp) warnedInArray.push("WHATSAPP");
			if (messageData?.isMail) warnedInArray.push("EMAIL");
			setSendMessagePayload({ ...basePayload, warnedIn: warnedInArray });
		}
		else if (messageData?.isMail && setSendMailPayload) {
			setSendMailPayload({ ...basePayload, warnedIn: ["EMAIL"] });
		}
	};

	const updateMessageData = (updates) => {
		setMessageData(prev => ({ ...prev, ...updates }));
	};

	const handleMessageCheck = (check, type) => {
		if (type === "whatsapp") {
			updateMessageData({ isWhatsapp: check });
		}
		else if (type === "mail") {
			updateMessageData({ isMail: check });
		}
		else if (type === "warning") {
			updateMessageData({ warning: check });
		}
	};

	const handleMessageChange = (fieldValue, fieldName) => {
		if (fieldName && updateMessageData) {
			updateMessageData({ [fieldName]: fieldValue || "" });
		}
	};

	const getPdfTitle = (reportType) => {
		if (reportType === "LAWYERS") {
			return "Complaint Details in Lawyer";
		} else if (reportType === "CUSTOMERS") {
			return "Complaint Details in Customer";
		}
		return "Complaint Details";
	};

	const handleSendMessage = (messageType) => {
		if (!messageType || !screenState?.drawerComplaintData) return;
		const complaintData = screenState?.drawerComplaintData;
		if (messageType === "sendMessage") {
			if (setConsultationBooleans) {
				setConsultationBooleans(prev => ({ ...prev, isSendMessage: true, isSendWarningMessage: false }));
			}
			if (updateMessageData) {
				updateMessageData({
					complaintType: complaintData?.complaintType || "",
					warning: false,
					againstById: complaintData?.againstById || "",
					raisedById: complaintData?.raisedById || "",
					complaintId: complaintData?.complaintId || "",
					warnedBy: userId || ""
				});
			}
		} else if (messageType === "sendWarningMessage") {
			if (setConsultationBooleans) {
				setConsultationBooleans(prev => ({ ...prev, isSendMessage: false, isSendWarningMessage: true }));
			}
			if (updateMessageData) {
				updateMessageData({
					complaintType: complaintData?.complaintType || "",
					warning: true,
					againstById: complaintData?.againstById || "",
					raisedById: complaintData?.raisedById || "",
					complaintId: complaintData?.complaintId || "",
					warnedBy: userId || ""
				});
			}
		}
	};

	const handleMessageClose = () => {
		if (setConsultationBooleans) {
			setConsultationBooleans(prev => ({ ...prev, isSendMessage: false, isSendWarningMessage: false }));
		}
		if (updateMessageData) {
			updateMessageData({
				message: "",
				template: "",
				sendTo: "",
				subject: "",
				body: "",
				isWhatsapp: false,
				isMail: true,
				activeTabKey: "1",
				activeTab: "raised",
				complaintType: "",
				raisedById: "",
				againstById: "",
				warning: false,
				complaintId: "",
				warnedBy: userId || ""
			});
		}
	};
	const handleConsultationClose = () => {
		setConsultationBooleans(prev => ({ ...prev, isconsultationDrawerOpen: false }));
	};

	useEffect(() => {
		if (sendMessagePayload) {
			refetchWhatsApp();
		}
	}, [sendMessagePayload, refetchWhatsApp]);

	useEffect(() => {
		if (sendMailPayload) {
			refetchMail();
		}
	}, [sendMailPayload, refetchMail]);

	useEffect(() => {
		if (screenState?.isReportOpen) {
			handlePrint();
		}
	}, [screenState?.isReportOpen, handlePrint]);

	useEffect(() => {
		const isLoading = isFetchingComplaintDetails || isFetchingComplaintById || isFetchingSendMessage || isFetchingSendMail || isFetchingCompleteComplaint || isFetchingConsultationById || refundModal?.loading;
		dispatch(loaderReducer(isLoading));
	}, [dispatch, isFetchingComplaintDetails, isFetchingComplaintById, isFetchingSendMessage, isFetchingSendMail, isFetchingCompleteComplaint, isFetchingConsultationById, refundModal?.loading]);

	useEffect(() => {
		const isMail = messageData?.isMail ?? true;
		const isButtonEnable = Boolean(messageData?.subject && messageData?.body && (messageData?.isWhatsapp || isMail));
		if (messageData?.isButtonEnable !== isButtonEnable) {
			updateMessageData({ isButtonEnable: isButtonEnable });
		}
	}, [messageData?.subject, messageData?.body, messageData?.isWhatsapp, messageData?.isMail, messageData?.isButtonEnable]);

	const totalComplaintCount = complaintDetailsData?.result?.complaintResponsePage?.totalElements || 0;
	const shouldShowComplaintPagination = totalComplaintCount > 10;

	return <>
		<div>
			<div className="flexible">
				<h6 style={{ padding: "10px", margin: 0 }}>Complaint</h6>
				<div className="flexible">
					<UiSelect
						options={complaintStatusOptions}
						name="complaintStatus"
						style={{ width: "120px" }}
						onChange={(field) => handleComplaintStatusChange(field)}
						value={screenState?.complaintStatus || "Select"}
						allowClear={false}
					/>
					<DatePicker picker="month" format="MMM"
						value={screenState?.selectMonth || null}
						onChange={(month) => handleMonthChange(month, "compliant")}
						disabledDate={(current) => current && current > dayjs().endOf("day")}
						style={{ height: 32, width: 150, borderRadius: 6 }}
					/>
					<UiRangePicker value={screenState?.date?.fromDate && screenState?.date?.toDate ? [dayjs(screenState?.date?.fromDate), dayjs(screenState?.date?.toDate)] : null} onChange={(date) => handleDateChange(date, "compliant")} disabledDate={(current) => current && current > dayjs().endOf("day")} />
					<UiSearch placeholder="Complaint ID" onChange={(search) => handleSearch(search.target.value)} value={screenState?.searchFilter || ""} />
					<UiButton type="primary" onClick={handleReportPrint}> <img src={downloadReport} alt="" />Download Report</UiButton>
				</div>
			</div>
			<UiTab tabs={tabData || []} onChange={handleTabChanges} activeTabKey={screenState?.activeTabKey} count={complaintDetailsData?.result?.complaintResponsePage?.totalElements || 0} />
			<UiTable
				dataSource={screenState?.complaintData && Array.isArray(screenState?.complaintData) ? screenState?.complaintData : []}
				columns={screenState?.activeTab === "LAWYERS" && LAWYERS_COLUMNS ? LAWYERS_COLUMNS({ actionRender, complaintStatusOptions: screenState?.complaintStatus }) : CUSTOMERS_COLUMNS && CUSTOMERS_COLUMNS({ actionRender, complaintStatusOptions: screenState?.complaintStatus })}
				onRow={(complaintDetail) => ({
					onClick: () => handleComplaintRowClick(complaintDetail)
				})}
				scroll={{ y: "calc(100vh - 280px)" }}
				pagination={screenState?.isReportOpen || !shouldShowComplaintPagination ? false : {
					pageSize: screenState?.pageSize?.size || 10,
					current: screenState?.pageSize?.page + 1,
					total: totalComplaintCount,
					pageSizeOptions: tablePageSizeOptions,
					showSizeChanger: true,
					onChange: (page, size) => handlePagination(page, size)
				}}
			/>
		</div>
		<div style={{ display: "none" }}>
			{reportRef && <PrintAllCompliantReport
				ref={reportRef}
				data={screenState?.complaintData && Array.isArray(screenState?.complaintData) ? screenState?.complaintData : []}
				date={screenState?.date || { fromDate: "", toDate: "" }}
				reportType={screenState?.activeTab || ""}
				getPdfTitle={getPdfTitle || (() => "")}
				complaintStatus={screenState?.complaintStatus}
				selectedMonth={screenState?.selectMonth}
				selectedMonthString={screenState?.selectedMonthString}
			/>}
		</div>
		<ComplaintActionDrawer
			isOpen={screenState?.isOpen || false}
			complaintData={screenState?.drawerComplaintData || null}
			consultation={screenState?.consultation || null}
			messageModalOpen={screenState?.messageModalOpen || false}
			isWarningMessage={screenState?.isWarningMessage || false}
			messageData={messageData || {}}
			raisedByProfileUrl={screenState?.raisedByProfileUrl || null}
			againstByProfileUrl={screenState?.againstByProfileUrl || null}
			againstByWarningCount={screenState?.drawerComplaintData?.againstByWarningCount || 0}
			consultationBooleans={consultationBooleans || {}}
			updateConsultationBooleans={setConsultationBooleans || (() => { })}
			showWhatsapp={false}
			onClose={() => {
				if (setScreenState) {
					setScreenState(prev => ({
						...prev,
						isOpen: false,
						drawerComplaintData: null,
						selectedComplaintId: null,
						raisedByProfileUrl: null,
						againstByProfileUrl: null,
						consultation: null
					}));
				}
				if (setConsultationBooleans) {
					setConsultationBooleans(prev => ({
						...prev,
						isComplaintDrawerOpen: false
					}));
				}
			}}
			onSendMessage={handleSendMessage}
			onMessageClose={handleMessageClose}
			onMessageChange={handleMessageChange}
			onMessageTabChange={(key) => handleMessageTabChange(key, setMessageData)}
			onMessageCheck={handleMessageCheck}
			onSubmitMessage={handleSubmitMessage}
			onRefund={
				screenState?.activeTab !== "CUSTOMERS" &&
					screenState?.drawerComplaintData?.complaintType !== "COMPLAINT_RAISED_LAWYER" &&
					screenState?.drawerComplaintData?.consultationDetails?.consultationPaymentDetails?.customerTransactionId
					? () => handleOpenRefundModal(screenState?.drawerComplaintData)
					: undefined
			}
			isRefundDisabled={Boolean(
				screenState?.drawerComplaintData?.consultationDetails?.refundId ||
				screenState?.drawerComplaintData?.consultationDetails?.isRefunded ||
				screenState?.drawerComplaintData?.consultationDetails?.refundStatus === "REFUNDED" ||
				screenState?.drawerComplaintData?.consultationDetails?.refundStatus === "SUCCESS" ||
				(screenState?.drawerComplaintData?.consultationDetails?.refundAmount && Number(screenState?.drawerComplaintData?.consultationDetails?.refundAmount) > 0) ||
				isConsultationRefundExpired(screenState?.drawerComplaintData?.consultationDetails?.consultationDate || screenState?.drawerComplaintData?.consultationDate)
			)}
		/>
		<Modal
			open={completeModal?.open}
			onCancel={handleCloseCompleteModal}
			footer={null}
			centered
			width={400}
			closable={false}
			className="complete-complaint-modal"
		>
			<div className="modal-content" style={{ textAlign: 'center', padding: '10px' }}>
				<div style={{ display: 'flex', justifyContent: 'center', marginBottom: '16px' }}>
					<ExclamationCircleOutlined style={{ fontSize: '48px', color: '#faad14' }} />
				</div>
				<p style={{ fontSize: '16px', marginBottom: '24px' }}>Are you sure you want to resolve this issue ?</p>
				<div className="button-container" style={{ display: 'flex', justifyContent: 'center', gap: '12px' }}>
					<UiButton
						onClick={handleCloseCompleteModal}
						disabled={isFetchingCompleteComplaint}
					>
						Cancel
					</UiButton>
					<UiButton
						type="primary"
						disabled={isFetchingCompleteComplaint}
						onClick={handleConfirmComplete}
					>
						Confirm
					</UiButton>
				</div>
			</div>
		</Modal>
		<Modal
			open={refundModal?.open}
			onCancel={() => setRefundModal({
				open: false,
				loading: false,
				consultationNo: "",
				customerName: "",
				customerTransactionId: "",
				totalAmount: 0,
				amount: "",
				percentage: "100%",
				userId: "",
				consultationId: "",
				complaintId: null,
				refundId: null
			})}
			footer={null}
			centered
			width={440}
			closable={false}
			zIndex={2000}
			className="refund-confirm-modal"
		>
			<div className="modal-content" style={{ padding: "16px", textAlign: "center" }}>
				<div style={{ display: "flex", justifyContent: "center", marginBottom: "16px" }}>
					<ExclamationCircleOutlined style={{ fontSize: "48px", color: "#faad14" }} />
				</div>
				<h3 style={{ fontSize: "18px", fontWeight: "600", marginBottom: "12px", color: "#1f1f1f" }}>
					Confirm Refund
				</h3>
				<p style={{ fontSize: "14px", color: "#595959", marginBottom: "16px" }}>
					Are you sure you want to process a refund for consultation <strong>{refundModal?.consultationNo || ""}</strong>?
				</p>
				<div style={{ backgroundColor: "#f5f5f5", borderRadius: "8px", padding: "12px", marginBottom: "16px", textAlign: "left" }}>
					<div style={{ display: "flex", justifyContent: "space-between", marginBottom: "6px" }}>
						<span style={{ color: "#8c8c8c", fontSize: "13px" }}>Customer:</span>
						<span style={{ fontWeight: "500", fontSize: "13px" }}>
							{refundModal?.customerName || "-"}
						</span>
					</div>
					<div style={{ display: "flex", justifyContent: "space-between", marginBottom: "6px" }}>
						<span style={{ color: "#8c8c8c", fontSize: "13px" }}>Transaction ID:</span>
						<span style={{ fontWeight: "500", fontSize: "13px" }}>
							{refundModal?.customerTransactionId || "-"}
						</span>
					</div>
					<div style={{ display: "flex", justifyContent: "space-between" }}>
						<span style={{ color: "#8c8c8c", fontSize: "13px" }}>Total Amount:</span>
						<span style={{ fontWeight: "600", fontSize: "14px", color: "#005D60" }}>
							₹ {formatAmount(refundModal?.totalAmount || 0)}
						</span>
					</div>
				</div>
				<div style={{ textAlign: "left", marginBottom: "20px" }}>
					<label style={{ fontSize: "13px", fontWeight: "500", color: "#595959", display: "block", marginBottom: "6px" }}>
						Refund Percentage & Amount:
					</label>
					<div style={{ display: "flex", gap: "12px", alignItems: "center" }}>
						<div style={{ flex: 1 }}>
							<UiSelect
								options={refundPercentageOptions}
								value={refundModal?.percentage || null}
								placeholder="Select %"
								onChange={(val) => handleRefundPercentageChange(val)}
								allowClear={false}
								style={{ width: "100%", height: "36px" }}
							/>
						</div>
						<div style={{ flex: 1 }}>
							<input
								type="text"
								readOnly
								disabled
								placeholder="Refund amount"
								value={formatAmount(refundModal?.amount)}
								style={{
									width: "100%",
									height: "36px",
									padding: "0 10px",
									borderRadius: "4px",
									border: "1px solid #d9d9d9",
									boxSizing: "border-box",
									fontSize: "14px",
									backgroundColor: "#f5f5f5",
									color: "#000000d9",
									cursor: "not-allowed"
								}}
							/>
						</div>
					</div>
				</div>
				<div style={{ display: "flex", justifyContent: "center", gap: "12px" }}>
					<UiButton
						onClick={() => setRefundModal({
							open: false,
							loading: false,
							consultationNo: "",
							customerName: "",
							customerTransactionId: "",
							totalAmount: 0,
							amount: "",
							percentage: "100%",
							userId: "",
							consultationId: "",
							complaintId: null,
							refundId: null,
							record: false
						})}
						disabled={refundModal?.loading}
					>
						Cancel
					</UiButton>
					<UiButton
						type="primary"
						disabled={refundModal?.loading}
						onClick={handleConfirmRefund}
					>
						{refundModal?.loading ? "Processing..." : "Confirm Refund"}
					</UiButton>
				</div>
			</div>
		</Modal>
		{consultationBooleans?.isconsultationDrawerOpen && (
			<ConsultationView
				consultation={consultation}
				consultationBooleans={consultationBooleans}
				consultationIdData={consultationIdData}
				handleConsultationClose={handleConsultationClose}
				onRefund={() => handleOpenRefundModal(consultationIdData?.consultationInfo)}
				isRefundDisabled={Boolean(
					consultationIdData?.consultationInfo?.isRefunded ||
					consultationIdData?.consultationInfo?.refundStatus === "REFUNDED" ||
					consultationIdData?.consultationInfo?.refundStatus === "SUCCESS" ||
					Number(consultationIdData?.consultationInfo?.refundAmount || 0) > 0 ||
					isConsultationRefundExpired(consultationIdData?.consultationInfo?.consultationDate)
				)}
			/>
		)}
	</>;
};

export default Compliant;
